export default __webpack_public_path__ + "static/media/icon_user_event.b37b8ba5.svg";